import { Reveal, Eyebrow } from "./Reveal";
import { MagneticCTA } from "./MagneticCTA";
import { Sparkle } from "./Sparkle";
import { BOOKING_URL } from "../../data/site";

export const BookingBand = () => (
  <section
    data-testid="booking-band"
    className="relative bg-espresso py-24 sm:py-32 overflow-hidden"
  >
    <Sparkle size={26} className="absolute top-12 left-[12%] twinkle opacity-40" />
    <Sparkle size={16} className="absolute bottom-16 right-[15%] twinkle opacity-30" />
    <Sparkle size={12} className="absolute top-1/2 right-[8%] twinkle opacity-20" />
    <div className="max-w-3xl mx-auto px-6 text-center">
      <Reveal>
        <Eyebrow light>Reserve Your Moment</Eyebrow>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ivory mt-6 leading-[1.1]">
          Your Best Look Starts With{" "}
          <span className="italic text-gold">One Appointment</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="font-quote italic text-xl sm:text-2xl text-ivory/70 mt-6">
          Private consultations available — reserve your spot today.
        </p>
      </Reveal>
      <Reveal delay={0.3} className="mt-10">
        <MagneticCTA href={BOOKING_URL} variant="solid" testId="booking-band-cta" ariaLabel="Book an appointment (opens in a new tab)">
          Book Now
        </MagneticCTA>
      </Reveal>
    </div>
  </section>
);
